/**
 * 必要人時 API クライアント
 */

import { authFetch, API_BASE_URL } from "./client";

export interface ManHourRequiredResponse {
    id: number;
    tenant_id: string;
    organization_id: number;
    weekday: number;
    row_no: number;
    start_time: string; // "HH:MM:SS"
    end_time: string;   // "HH:MM:SS"
}

export interface ManHourRequiredListResponse {
    items: ManHourRequiredResponse[];
    total: number;
}

export interface ManHourRequiredRowInput {
    row_no: number;
    start_time: string; // "HH:MM:SS"
    end_time: string;   // "HH:MM:SS"
}

export interface ManHourRequiredBulkSaveRequest {
    organization_id: number;
    weekday: number;
    rows: ManHourRequiredRowInput[];
}

/** 指定曜日・組織の必要人時一覧を取得 */
export async function fetchManHourRequired(params: {
    weekday: number;
    organization_id: number;
}): Promise<ManHourRequiredListResponse> {
    const searchParams = new URLSearchParams();
    searchParams.set("weekday", String(params.weekday));
    searchParams.set("organization_id", String(params.organization_id));

    const url = `${API_BASE_URL}/man-hour-required?${searchParams.toString()}`;
    const response = await authFetch(url);
    if (!response.ok) throw new Error(`Failed to fetch man_hour_required: ${response.status}`);
    return response.json();
}

/** 組織×曜日の必要人時を一括保存（全置換） */
export async function bulkSaveManHourRequired(
    data: ManHourRequiredBulkSaveRequest,
): Promise<ManHourRequiredListResponse> {
    const response = await authFetch(`${API_BASE_URL}/man-hour-required/bulk`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
    });
    if (!response.ok) throw new Error(`Failed to save man_hour_required: ${response.status}`);
    return response.json();
}
